/* Live fix 2026-09-30 (item 10, owner QA): the Klaviyo sign-up popup (form WRgBV6) opened ~6s after Add to bag,
   on top of the open cart drawer, and covered "Check out". The theme now keeps Klaviyo popups and flyouts out of
   the way while the shopper is buying:
   - while the cart drawer is open,
   - on /cart,
   - for the rest of the page view after an Add to bag (PDP, cards, quiz, search).
   The form is only hidden, never closed, so Klaviyo does not record a dismissal and can show it on a later page.
   Everywhere else the popup behaves exactly as set up in Klaviyo. Nothing is changed in Klaviyo itself. */
(() => {
  const root = document.documentElement;
  if (root.dataset.nhKlHush) return;
  root.dataset.nhKlHush = '1';
  const onCart = /^\/cart\/?$/.test(location.pathname);
  /* 2026-10 place pages (QA PL-01): never show the Klaviyo popup on the NZ delivery hub, the place pages or the Access
     Index. It opened over the "Do we deliver to you?" checker ~16 s in and took the shopper's typing. Hidden, not
     dismissed, so Klaviyo can still show it on the next page. Test views (?view=nh-...) are covered too. */
  const onPlace = /^\/pages\/(sex-toys\/|sex-toy-delivery-nz|adult-shop-access-index)/.test(location.pathname) ||
    /^nh-(place|access)/.test(new URLSearchParams(location.search).get('view') || '');
  let added = false;
  const style = document.createElement('style');
  style.textContent = [
    'html.nh-kl-hush div.kl-private-reset-css-Xuajs1[role="dialog"],',
    'html.nh-kl-hush [data-testid="POPUP"], html.nh-kl-hush [data-testid="FLYOUT"],',
    'html.nh-kl-hush [data-testid="FULLSCREEN"] { display: none !important; }',
    'html.nh-kl-hush body.klaviyo-prevent-body-scrolling { overflow: visible !important; }'
  ].join('\n');
  document.head.appendChild(style);
  const drawer = () => document.getElementById('CartDrawer');
  const drawerOpen = () => !!drawer()?.classList.contains('drawer--is-open');
  /* 2026-10-01 (Dori QA): also hidden while the Nova chat (Dori Side Pal) is open, so the popup never opens over a
     shopper who is typing to Nova. html.nh-dori-open and the nh:dori event come from assets/nh-dori-tame.js. */
  const doriOpen = () => root.classList.contains('nh-dori-open');
  const sync = () => root.classList.toggle('nh-kl-hush', onCart || onPlace || added || drawerOpen() || doriOpen());
  document.addEventListener('ajaxProduct:added', () => { added = true; sync(); });
  document.addEventListener('nh:dori', sync);
  const watch = () => {
    const d = drawer();
    if (d) new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch, { once: true }); else watch();
  // Klaviyo moves focus into a popup when it opens. If that popup is hidden, hand focus back (to where it was, else
  // to the open cart drawer, else the page), so keys never reach the hidden form: Escape then closes only the drawer
  // and the popup stays intact for a later page (live polish 2026-09-30, FE-0930-04).
  const inKl = (el) => !!(el && el.closest && el.closest('.kl-private-reset-css-Xuajs1, [data-testid="POPUP"], [data-testid="FLYOUT"], [data-testid="FULLSCREEN"]'));
  const hushed = () => root.classList.contains('nh-kl-hush');
  let lastFocus = null;
  const giveBack = () => {
    if (lastFocus && lastFocus !== document.body && document.contains(lastFocus) && !inKl(lastFocus)) { lastFocus.focus({ preventScroll: true }); return; }
    const d = drawer();
    const close = drawerOpen() && d.querySelector('.js-drawer-close, [aria-label*="lose"], button');
    if (close) { close.focus({ preventScroll: true }); return; }
    if (inKl(document.activeElement)) document.activeElement.blur();
  };
  document.addEventListener('focusin', (e) => {
    if (!inKl(e.target)) { lastFocus = e.target; return; }
    if (hushed()) giveBack();
  });
  // Belt and braces: an Escape aimed at the hidden form is stopped before Klaviyo sees it. The theme's drawers close
  // on keyup, so the shopper's Escape still closes the cart drawer.
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && hushed() && inKl(e.target)) { e.stopImmediatePropagation(); giveBack(); }
  }, true);
  window.addEventListener('klaviyoForms', (e) => {
    if (!e.detail || e.detail.type !== 'open' || !hushed()) return;
    setTimeout(() => { const a = document.activeElement; if (!a || a === document.body || inKl(a)) giveBack(); }, 60);
  });
})();
